

export const calculateTitleSize = (length: number, width: number) => {
    let wConst = 1920
    if (width < 750) {
      wConst = 1200
    }
    let textSize = Math.floor(32 * (width / wConst))

    return `${textSize}px`
  }

export const calculateSize = (fSize: number, width: number) => {
    let wConst = 1920
    if (width < 750) {
      wConst = 800
    }
    let textSize = Math.floor(fSize * (width / wConst))

    return `${textSize}px`
  }